<div class="imaging-cases-container">
  <mat-toolbar color="primary">
    <mat-icon>folder_special</mat-icon>
    <span style="margin-left: 8px;">Imaging Cases</span>
    <span class="toolbar-spacer"></span>
    <button mat-raised-button (click)="goToUpload()">
      <mat-icon>add</mat-icon>
      Upload New Disk
    </button>
  </mat-toolbar>

  <div class="content-area">

    <!-- Search -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search by case label</mat-label>
      <input matInput [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" placeholder="e.g. Smith v Hospital" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading cases&hellip;</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && filteredCases.length === 0" class="empty-state">
      <mat-icon class="empty-icon">folder_open</mat-icon>
      <h3>No imaging cases found</h3>
      <p *ngIf="searchQuery">No cases match your search.</p>
      <p *ngIf="!searchQuery">Upload a disk to create the first case.</p>
      <button *ngIf="!searchQuery" mat-raised-button color="primary" (click)="goToUpload()">
        <mat-icon>cloud_upload</mat-icon>
        Upload a Disk
      </button>
    </div>

    <!-- Cases table -->
    <mat-table *ngIf="!loading && filteredCases.length > 0"
               [dataSource]="filteredCases"
               class="cases-table mat-elevation-z1">

      <!-- Label column -->
      <ng-container matColumnDef="label">
        <mat-header-cell *matHeaderCellDef>Case Label</mat-header-cell>
        <mat-cell *matCellDef="let c">
          <span class="case-label">{{ c.label }}</span>
        </mat-cell>
      </ng-container>

      <!-- Status column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let c">
          <span class="status-chip" [ngClass]="statusColor(c.status)">
            <mat-icon class="status-chip-icon"
              [class.spin]="c.status === 'processing'">
              {{ statusIcon(c.status) }}
            </mat-icon>
            {{ c.status }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Uploads column -->
      <ng-container matColumnDef="uploads">
        <mat-header-cell *matHeaderCellDef>Uploads</mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.uploadSessionIds?.length || 0 }}
        </mat-cell>
      </ng-container>

      <!-- Clio column -->
      <ng-container matColumnDef="clio">
        <mat-header-cell *matHeaderCellDef>Clio Matter</mat-header-cell>
        <mat-cell *matCellDef="let c">
          <span *ngIf="c.clioMatterName" class="clio-linked">
            <mat-icon class="clio-icon">link</mat-icon>
            {{ c.clioMatterName }}
          </span>
          <span *ngIf="!c.clioMatterName" class="clio-unlinked">—</span>
        </mat-cell>
      </ng-container>

      <!-- Date column -->
      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.createdAt?.toDate ? (c.createdAt.toDate() | date:'mediumDate') : '—' }}
        </mat-cell>
      </ng-container>

      <!-- Actions column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let c">
          <button mat-icon-button matTooltip="Open" (click)="openDetail(c.id)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let c; columns: displayedColumns;"
               class="case-row"
               (click)="openDetail(c.id)">
      </mat-row>
    </mat-table>

  </div>
</div>
